import { render, staticRenderFns } from "./PlayerModal.vue?vue&type=template&id=11b467d0&scoped=true"
import script from "./PlayerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlayerModal.vue?vue&type=style&index=0&id=11b467d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b467d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b467d0')) {
      api.createRecord('11b467d0', component.options)
    } else {
      api.reload('11b467d0', component.options)
    }
    module.hot.accept("./PlayerModal.vue?vue&type=template&id=11b467d0&scoped=true", function () {
      api.rerender('11b467d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PlayerModal.vue"
export default component.exports